import { FcpaEnums } from "@/common/constant";

interface ICard {
  key: FcpaEnums;
  index: number;
  name: string;
  chineseName: string;
  icon: string;
  iconGrey: string;
}

export const fcpaIcon = {
  familiar: "https://commimg.pddpic.com/upload/dmp/ff.png",
  consider:
    "https://commimg.pddpic.com/upload/msfe/ca18ab4f-2e29-4d83-a1c3-d9f127cb05b7.png",
  purchase:
    "https://commimg.pddpic.com/upload/msfe/b806f63c-ea40-4fed-8360-c0967c00c6f9.png",
  advocate:
    "https://commimg.pddpic.com/upload/msfe/5075b0cd-8227-4a7c-8763-8f14286affe6.png",
};

const fcpaIconGrey = {
  familiar: "https://commimg.pddpic.com/upload/dmp/f.png.slim.png",
  consider: "https://commimg.pddpic.com/upload/dmp/c.png.slim.png",
  purchase: "https://commimg.pddpic.com/upload/dmp/p.png.slim.png",
  advocate: "https://commimg.pddpic.com/upload/dmp/a.png.slim.png",
};

/** @deprecated check src/views/menu_layout/crowd_distribute/components/distribute_type_select.tsx */
export const cardData: ICard[] = [
  {
    key: FcpaEnums.FAMILIAR,
    index: 0,
    name: "认知 Familiar",
    chineseName: "认知",
    icon: fcpaIcon.familiar,
    iconGrey: fcpaIconGrey.familiar,
  },
  {
    key: FcpaEnums.CONSIDER,
    index: 1,
    name: "兴趣 Consider",
    chineseName: "兴趣",
    icon: fcpaIcon.consider,
    iconGrey: fcpaIconGrey.consider,
  },
  {
    key: FcpaEnums.PURCHASE,
    index: 2,
    name: "购买 Purchase",
    chineseName: "购买",
    icon: fcpaIcon.purchase,
    iconGrey: fcpaIconGrey.purchase,
  },
  {
    key: FcpaEnums.ADVOCATE,
    index: 3,
    name: "忠诚 Advocate",
    chineseName: "忠诚",
    icon: fcpaIcon.advocate,
    iconGrey: fcpaIconGrey.advocate,
  },
];
